import type { ExtendedMultiLocationSuggestOption } from '../shared/model/constants/filterTypes';
import localStorageService from '../client/service/localStorage';

const MAX_RECENT_LOCATIONS_INDEX = 7;
const RECENT_LOCATIONS_LOCAL_STORAGE_KEY = 'rca-recentLocations';
const { getItem, setItem } = localStorageService();

const getLocalStorageRecentLocations = (): ExtendedMultiLocationSuggestOption[][] | undefined =>
  (getItem && getItem(RECENT_LOCATIONS_LOCAL_STORAGE_KEY)
    ? (JSON.parse(
      getItem(RECENT_LOCATIONS_LOCAL_STORAGE_KEY),
    ) as ExtendedMultiLocationSuggestOption[][])
    : undefined);

export const setRecentLocations = (
  searchLocations: ExtendedMultiLocationSuggestOption[] | undefined,
): void => {
  const recentLocations =
    getItem && getItem(RECENT_LOCATIONS_LOCAL_STORAGE_KEY)
      ? (JSON.parse(
        getItem(RECENT_LOCATIONS_LOCAL_STORAGE_KEY),
      ) as ExtendedMultiLocationSuggestOption[])
      : [];
  const newRecentLocations =
    searchLocations !== undefined && searchLocations !== null
      ? [searchLocations, ...recentLocations].slice(0, MAX_RECENT_LOCATIONS_INDEX)
      : [];

  if (setItem) {
    setItem(RECENT_LOCATIONS_LOCAL_STORAGE_KEY, JSON.stringify(newRecentLocations));
  }
};

export const getRecentLocations = (): ExtendedMultiLocationSuggestOption[] => {
  const recentLocationsArray = getLocalStorageRecentLocations();

  return recentLocationsArray?.[0] ?? [];
};

export const getFirstLocationState = (): string => {
  const recentLocationsArray = getRecentLocations();
  if (recentLocationsArray.length === 0) {
    return 'null';
  }
  return recentLocationsArray[0].source?.state ?? 'null';
};

export const getLocationSearchRecentLocations = (): ExtendedMultiLocationSuggestOption[] => {
  const recentLocationsArray = getLocalStorageRecentLocations();
  const locationIds = new Set<string>();

  const sanitisedRecentLocations = recentLocationsArray?.reduce(
    (validLocationSearches, recentLocationSearch) => {
      const isSingleLocationSearch = recentLocationSearch.length === 1;
      const locationSearchId = recentLocationSearch[0]?.id;

      if (isSingleLocationSearch && locationSearchId && !locationIds.has(locationSearchId)) {
        locationIds.add(locationSearchId);
        validLocationSearches.push(recentLocationSearch[0]);
      }
      return validLocationSearches;
    },
    [],
  );

  return sanitisedRecentLocations ?? [];
};
